// extracted by mini-css-extract-plugin
module.exports = {"all":"Pronostico_all__1Lz49","team":"Pronostico_team__2cq2_","team2":"Pronostico_team2__10pBN","result":"Pronostico_result__3TGe9"};